import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BillsByCounterpartyItem } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";
import classNames from "classnames";
import styles from "./VendorNameCell.module.scss";

export const VendorNameCell = memo(
    ({ row }: CellContext<ViewTableFeatures, BillsByCounterpartyItem, any>) => {
        const item = row.original;

        return (
            <ViewTableCell>
                <div className={styles.vendorContent}>
                    {item.counterparty ? (
                        <>
                            <span className={styles.vendorName}>
                                {item.counterparty.name}
                            </span>
                            {item.counterparty.email && (
                                <CopyOnClick
                                    className={classNames(
                                        styles.vendorEmail,
                                        styles.leftAligned,
                                    )}
                                    value={item.counterparty.email}
                                    tooltipText="Copy email"
                                >
                                    {item.counterparty.email}
                                </CopyOnClick>
                            )}
                        </>
                    ) : (
                        <span className={styles.noVendor}>No vendor</span>
                    )}
                </div>
            </ViewTableCell>
        );
    },
);
